// extracted by mini-css-extract-plugin
module.exports = {"container":"FullWidthTableLayout_container__2L1oc"};